class DonationAmountPicker extends HTMLElement {
  constructor() {
    super();
    this.amountInputs = this.querySelectorAll('[data-amount]');
    this.customInput = this.querySelector('[data-custom-amount]');
    this.frequencyInputs = this.querySelectorAll('input[name^="DonationFrequency"]');
    this.donateLinks = document.querySelectorAll('[data-donate-link]');

    this.amountInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (this.customInput) this.customInput.value = input.dataset.amount;
        this.updateLink();
      });
    });

    if (this.customInput) {
      this.customInput.addEventListener('input', () => {
        this.amountInputs.forEach((input) => (input.checked = false));
        this.updateLink();
      });
    }

    this.frequencyInputs.forEach((input) => {
      input.addEventListener('change', () => this.updateLink());
    });

    this.updateLink();
  }

  updateLink() {
    const amount = this.customInput ? this.customInput.value : '';
    const checkedFrequency = this.querySelector('input[name^="DonationFrequency"]:checked');

    this.donateLinks.forEach((link) => {
      const base = link.dataset.baseLink || '';
      if (!base) return;

      try {
        const url = new URL(base, window.location.href);
        // Qgiv: its preset buttons ($25–$1,500) are matched with amount=; any other figure fills its Custom box with otherAmount=
        url.searchParams.delete('amount');
        url.searchParams.delete('otherAmount');
        if (amount) {
          const qgivPresets = ['25', '50', '100', '500', '1000', '1500'];
          const cleaned = String(amount).replace(/[^0-9.]/g, '');
          if (cleaned) url.searchParams.set(qgivPresets.indexOf(cleaned) > -1 ? 'amount' : 'otherAmount', cleaned);
        }
        // Qgiv: recurring gifts are requested with frequency=monthly; one-time gifts send no frequency
        if (checkedFrequency && checkedFrequency.value === 'ongoing') {
          url.searchParams.set('frequency', 'monthly');
        } else {
          url.searchParams.delete('frequency');
        }
        link.setAttribute('href', url.toString());
      } catch (error) {
        // base link isn't a valid absolute/relative URL (e.g. a placeholder) — leave href untouched
      }
    });
  }
}

customElements.define('donation-amount-picker', DonationAmountPicker);

document.querySelectorAll('[data-sheet-bar-cta]').forEach((cta) => {
  cta.addEventListener('click', (event) => event.stopPropagation());
});

document.querySelectorAll('[data-sheet-toggle]').forEach((toggle) => {
  toggle.addEventListener('click', () => {
    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId && document.getElementById(panelId);
    if (!panel) return;

    const expanded = panel.classList.toggle('is-expanded');
    document
      .querySelectorAll(`[data-sheet-toggle][aria-controls="${panelId}"]`)
      .forEach((el) => el.setAttribute('aria-expanded', String(expanded)));
  });
});

const donateStickyBar = document.querySelector('[data-sheet-bar]');
const siteFooter = document.querySelector('footer.footer-ibu');

if (donateStickyBar && siteFooter) {
  const updateStickyBarOffset = () => {
    const footerTop = siteFooter.getBoundingClientRect().top;
    const reachesFooter = footerTop < window.innerHeight;
    donateStickyBar.classList.toggle('donation-sheet__bar--hidden', reachesFooter);
  };

  window.addEventListener('scroll', updateStickyBarOffset, { passive: true });
  window.addEventListener('resize', updateStickyBarOffset);
  updateStickyBarOffset();
}

const revealEls = document.querySelectorAll('.donate-reveal');

if (revealEls.length) {
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach((el) => revealObserver.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }
}
